$(document).ready(function(e) {
	function setCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays*24*60*60*1000));
			var expires = "expires="+ d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	
	function getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for(var i = 0; i <ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
							c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
							return c.substring(name.length, c.length);
					}
			}
			return "";
	}
	
	function checkCookie() {
		var tempcookie = getCookie("shownewsletter");
		if (tempcookie == 1) {
			// do nothing
			// $('#nlm-launch').click();

		}
		else {
			setCookie("shownewsletter", 1, 1); // ("name", value, exdays)
			$('#nlm-launch').click();
		}
	}

	checkCookie();


	let url = new URL(location.href);
	if (url.search==="?customer_posted=true") {
		$('#nlm-launch').click();
	}



});

